import CollectingInstitutionService from './collecting-institution.service';

export default {
  collectingInstitutionRegistry: ({ axios }) => ({
    collectingInstitutionService: new CollectingInstitutionService({ axios }),
  }),
};
